import { Arbeitstage } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';

// eslint-disable-next-line complexity
export function mapArbeitstageSoll(
  arbeitstageSoll: (0 | 1 | 2 | 3 | 4 | 5 | 6)[],
): keyof Arbeitstage {
  const anzahlTage = arbeitstageSoll.length;

  switch (anzahlTage) {
    case 1:
      return 'EIN_TAG';
    case 2:
      return 'ZWEI_TAGE';
    case 3:
      return 'DREI_TAGE';
    case 4:
      return 'VIER_TAGE';
    case 5:
      return 'FUENF_TAGE';
    case 6:
      return 'SECHS_TAGE';
    case 7:
      return 'SIEBEN_TAGE';
    default:
      return 'EIN_TAG';
  }
}
